import { Compass } from "lucide-react";

export const NotFound = ({ onHome }) => (
  <div data-testid="not-found-page" className="min-h-screen bg-[#050915] flex items-center justify-center px-6">
    <div className="max-w-md text-center">
      <Compass className="w-10 h-10 text-gold-400 mx-auto mb-5" strokeWidth={1.4} />
      <h1 className="font-display text-4xl sm:text-5xl text-slate-50">This page isn't here</h1>
      <p className="font-read text-slate-400 mt-4">The link may be old or mistyped. Your books are safe in your library.</p>
      <button data-testid="not-found-home" onClick={onHome}
        className="gold-pill rounded-full px-7 py-3 mt-8 font-ui text-sm">Back to KLYR Studio</button>
    </div>
  </div>
);
